const apiUrl = process.env.REACT_APP_API_URL;

export const FetchWithAuth = async (auth, url, body = null, options = {}) => {
	const token = auth.token || localStorage.getItem("token");

	const headers = {
		...options.headers,
		Authorization: `Bearer ${token}`,
		withCredentials: true,
	};

	if (body) {
		headers["Content-Type"] = "application/json";
		body = JSON.stringify(body);
	}

	return fetch(apiUrl + url, {
		method: options.method || "GET",
		headers,
		body,
	})
		.then((response) => {
			if (auth !== null && (response.status === 401 || response.status === 403)) auth.logout();
			if (response.status >= 400) return Promise.reject(response);
			return response;
		})
		.then((response) => response.json());
};
